import React, { Fragment } from "react"
import { useStaticQuery, Link, graphql } from "gatsby"
import Img from 'gatsby-image'

const RecentNews = () => {
    const data = useStaticQuery(graphql`
    query PostFrontmatter {
        allMarkdownRemark(sort: {fields: frontmatter___date, order: DESC}, limit: 2, filter: {fileAbsolutePath: {regex: "\\/blog/"}}) {
          edges {
            node {
              frontmatter {
                date(formatString: "Do MMM Y")
                excerpt
                title
                featuredImage {
                  childImageSharp {
                    fluid(maxWidth: 500) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
              fields {
                  slug
              }
            }
          }
        }
      }
    `
)
    return (
    <Fragment>
        <h1 className="gray-text pt-2 pt-md-0">Recent News</h1>
                    {data.allMarkdownRemark.edges.map(({ node }) => (
                        <div className="row pt-2 gray-text">
                            <div className="col">
                                <Link to={node.fields.slug}>
                                    <h2>{node.frontmatter.title}</h2>
                                </Link>
                                <p>{node.frontmatter.date}</p>
                                <p>{node.frontmatter.excerpt}</p>
                            </div>
                            <div className="col">
                                <Link to={node.fields.slug}>
                                    <Img sizes={node.frontmatter.featuredImage.childImageSharp.fluid}/>
                                </Link>
                            </div>
                        </div>
                    ))} 
    </Fragment>  
    )
}

export default RecentNews

export const query = graphql`
    query {
        allMarkdownRemark(sort: {fields: frontmatter___date, order: DESC}, limit: 1) {
            edges {
              node {
                frontmatter {
                  title
                  date
                  excerpt
                }
              }
            }
          }
        }
`